import Controller from '../abstracts/Controller';
import 'scss-templates/t-storelocator-search.scss';

export default class StoreLocatorController extends Controller {

  static get COMPONENTS() {
    return [
      "StoreLocatorComponent",
      "StoreLocatorFiltersComponent",
    ];
  }

  init() {
    super.init();
  }

}
